import {Component, OnDestroy, OnInit} from '@angular/core';
import {ContractualDataModel} from '../../../../models/ContractualDataModel';
import {Subscription} from 'rxjs';
import {LocalCustomerModel} from '../../../../models/LocalCustomerModel';
import {ContractTypeModel} from '../../../../models/ContractTypeModel';
import {ResourcesUnitModel} from '../../../../models/ResourcesUnitModel';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {ContractualValuesService} from '../service-contractual-values/contractual-values.service';
import {LoaderService} from '../../../general-services/service-loader/loader.service';
import {NumAnnoMeseService} from '../../../general-services/service-num-anno-mese/num-anno-mese.service';
import * as toastr from 'toastr';
import {DialogSubmitComponent} from '../../../general-components/dialog-submit/dialog-submit.component';
import {ProviderModel} from '../../../../models/ProviderModel';
import {ChargingMethodologyService} from '../../../general-services/service-charging-methodology/charging-methodology.service';
import {BaseGeneralComponent} from '../../../BaseGeneralComponent';
import {PriceRangeModel} from '../../../../models/PriceRangeModel';
import {SizeModel} from '../../../../models/SizeModel';
import {SiteModel} from '../../../../models/SiteModel';
import {RegionModel} from '../../../../models/RegionModel';
import {CurrencyModel} from '../../../../models/CurrencyModel';

@Component({
  selector: 'app-edit-contractual-values-massive',
  templateUrl: './edit-contractual-values-massive.component.html',
  styleUrls: ['./edit-contractual-values-massive.component.scss']
})
export class EditContractualValuesMassiveComponent extends BaseGeneralComponent implements OnInit, OnDestroy {

  contractualDataEdit: ContractualDataModel;
  getPageSubscribe: Subscription;
  contractualData: ContractualDataModel;
  localCustomerSelect: LocalCustomerModel;
  contractTypeSelect: ContractTypeModel;
  resourceUnitSelect: ResourcesUnitModel;
  providerSelect: ProviderModel;
  priceRangeListSelect: Array<PriceRangeModel>;
  regionSelect: RegionModel;
  chargingMethodologySelect: any;
  numAnnoMeseSelect: number;
  arcSelect: number;
  arc2Select: number;
  bmcSelect: number;
  bmvSelect: number;
  rrcSelect: number;
  rrc2Select: number;
  sizeSelect: SizeModel;
  siteSelect: SiteModel;
  currencySelect: CurrencyModel;

  bandwidth1Select: number;
  bandwidth2Select: number;
  pxqSelect: number;
  allMonth: any;
  allCharging: any;
  listData: MatTableDataSource<any>;
  contractualDataJson: any;

  saveContractualData: Subscription;
  parameterSubscribe: Subscription;
  getAllChargingMethodologySubscribe: Subscription;
  registerForm: FormGroup;
  submitted = false;
  enablePriceRange: boolean;
  resetPriceRange: boolean;
  enablePXQ: boolean;
  enableArcRrc: boolean;
  enableFixed: boolean;


  constructor(private route: ActivatedRoute, private router: Router,
              private contractualDataService: ContractualValuesService,
              private formBuilder: FormBuilder,
              private dialog: MatDialog,
              private loaderService: LoaderService,
              private annoMeseService: NumAnnoMeseService,
              private chargingMethodologyService: ChargingMethodologyService) {
    super();

    this.contractualData = new ContractualDataModel();
    this.localCustomerSelect = new LocalCustomerModel();
    this.contractTypeSelect = new ContractTypeModel();
    this.resourceUnitSelect = new ResourcesUnitModel();
    this.providerSelect = new ProviderModel();
    this.regionSelect = new RegionModel();
    this.currencySelect = new CurrencyModel();
  }

  ngOnInit() {
    this.parameterSubscribe = this.route
      .queryParams
      .subscribe(params => {
        this.contractualDataJson = params['row'];
      });
    this.contractualDataEdit = JSON.parse(this.contractualDataJson) as ContractualDataModel;

    this.numAnnoMeseSelect = this.contractualDataEdit.numAnnoMese;
    this.localCustomerSelect = this.contractualDataEdit.localCustomer;
    this.resourceUnitSelect = this.contractualDataEdit.resourceUnit;
    this.contractTypeSelect = this.contractualDataEdit.contractType;
    this.chargingMethodologySelect = this.contractualDataEdit.chargingMethodology;
    this.providerSelect = JSON.parse(sessionStorage.getItem(this.SESSION_STORAGE_LABELS.DEFAULT_PROVIDER_SELECTED)) as ProviderModel;
    this.regionSelect = this.contractualDataEdit.region;
    this.bmcSelect = this.contractualDataEdit.bmc;
    this.bmvSelect = this.contractualDataEdit.bmv;
    this.arcSelect = this.contractualDataEdit.arc;
    this.rrcSelect =  this.contractualDataEdit.rrc;
    this.sizeSelect = this.contractualDataEdit.size;
    this.siteSelect = this.contractualDataEdit.site;
    this.priceRangeListSelect = this.contractualDataEdit.priceRangeList;
    this.pxqSelect = this.contractualDataEdit.pxq;
    this.currencySelect = this.contractualDataEdit.currency;

    this.enablePriceRange = this.chargingMethodologySelect === this.CHARGING_METHODOLOGY.PRICE_RANGE;
    this.enableFixed = this.chargingMethodologySelect === this.CHARGING_METHODOLOGY.FIXED;
    this.enablePXQ = this.chargingMethodologySelect === this.CHARGING_METHODOLOGY.PXQ;
    this.enableArcRrc = this.chargingMethodologySelect === this.CHARGING_METHODOLOGY.ARC_RRC;

    this.registerForm = this.formBuilder.group({
      annoFrom: [{value: '', disabled: false}, Validators.required],
      annoTo: [{value: '', disabled: false}, Validators.required],
      localCustomerCod: [{value: '', disabled: false}, Validators.required],
      contractType: [{value: '', disabled: false}, Validators.required],
      resourceUnit: [{value: '', disabled: false}, Validators.required],
      providerCod: [{value: '', disabled: false}],
      region: [{value: '', disabled: false}, Validators.required],
      chargingMethodology: [{value: '', disabled: false}, Validators.required],
      compensationPayment: [{value: '', disabled: false}],
      terminationFee: [{value: '', disabled: false}],
      bmc: [{value: '', disabled: false}, Validators.required],
      bmv: [{value: '', disabled: false}, Validators.required],
      arc: [{value: '', disabled: false}, Validators.required],
      arc2: [{value: '', disabled: false}],
      rrc: [{value: '', disabled: false}, Validators.required],
      rrc2: [{value: '', disabled: false}],
      size: [{value: '', disabled: false}],
      site: [{value: '', disabled: false}],
      pxq: [{value: '', disabled: false}, Validators.required],
      bandwidth1: [{value: '', disabled: false}],
      bandwidth2: [{value: '', disabled: false}]
    });

    this.registerForm.patchValue({
      localCustomerCod: this.localCustomerSelect ? this.localCustomerSelect.cod : ''
    });

    this.registerForm.patchValue({
      contractType: this.contractTypeSelect ? this.contractTypeSelect.cod : ''
    });

    this.registerForm.patchValue({
      resourceUnit: this.resourceUnitSelect ? this.resourceUnitSelect.name : ''
    });

    this.registerForm.patchValue({
      providerCod: this.providerSelect ? this.providerSelect.cod : ''
    });

    this.registerForm.patchValue({
      region: this.regionSelect ? this.regionSelect.cod : ''
    });

    this.registerForm.patchValue({
      chargingMethodology: this.chargingMethodologySelect
    });

    this.registerForm.patchValue({
      bmc: this.bmcSelect ? this.bmcSelect : 0
    });

    this.registerForm.patchValue({
      bmv: this.bmvSelect ? this.bmvSelect : 0
    });

    this.registerForm.patchValue({
      arc: this.arcSelect ? this.arcSelect : 0
    });

    this.registerForm.patchValue({
      arc2: this.arc2Select ? this.arc2Select : 0
    });

    this.registerForm.patchValue({
      rrc: this.rrcSelect ? this.rrcSelect : 0
    });

    this.registerForm.patchValue({
      rrc2: this.rrc2Select ? this.rrc2Select : 0
    });

    this.registerForm.patchValue({
      size: this.sizeSelect ? this.sizeSelect.cod : null
    });

    this.registerForm.patchValue({
      site: this.siteSelect ? this.siteSelect.cod : null
    });

    this.registerForm.patchValue({
      bandwidth1: this.bandwidth1Select ? this.bandwidth1Select : null
    });

    this.registerForm.patchValue({
      bandwidth2: this.bandwidth2Select ? this.bandwidth2Select : null
    });

    this.registerForm.patchValue({
      pxq: this.pxqSelect ? this.pxqSelect : 0
    });

    this.contractualData.id = this.contractualDataEdit.id;
    this.contractualData.localCustomer = this.localCustomerSelect;
    this.contractualData.contractType = this.contractTypeSelect;
    this.contractualData.resourceUnit = this.resourceUnitSelect;
    this.contractualData.provider = this.providerSelect;
    this.contractualData.region = this.regionSelect;
    this.contractualData.chargingMethodology = this.chargingMethodologySelect;
    this.contractualData.numAnnoMese = this.numAnnoMeseSelect;
    this.contractualData.priceRangeList = this.priceRangeListSelect;
    this.contractualData.currency = this.currencySelect;

    this.getAllMonth();
    this.getAllChargingMethodology();
  }


  cancel(event: any) {
    event.preventDefault();
    this.router.navigate([this.LINKS.CONTRACTUAL_DATA], {queryParams: {selectedIndex: 0}});
  }

  save() {
    this.submitted = true;
    this.handleCharging(this.contractualData.chargingMethodology);
    if (this.registerForm.valid && this.checkRangeListValid()) {
      if (this.registerForm.value.annoFrom <= this.registerForm.value.annoTo) {
        event.preventDefault();
        this.updateFieldValues();
        this.loaderService.display(true);
        this.saveContractualData = this.contractualDataService.updateMassive(this.contractualDataService.baseUrl, this.contractualData)
          .subscribe(
            (result: any) => {
              if (result === -1) {
                toastr.options.timeout = 5000;
                toastr.warning('Duplicate item, cannot be created', 'Warning');
                this.loaderService.display(false);
              } else {
                this.loaderService.display(false);
                this.apriDialog(result);
                this.router.navigate([this.LINKS.CONTRACTUAL_DATA], {queryParams: {selectedIndex: 0}});
              }
            },
            error => {
              toastr.error('Contractual Value was not created', 'Error');
              this.loaderService.display(false);
            });
      } else {
        toastr.warning('"Year From" must be less than "Year To"', 'Warning');
      }
    }
  }

  updateFieldValues() {
    this.contractualData.numAnnoMese = null;
    this.contractualData.compensationPayment = this.registerForm.value.compensationPayment;
    this.contractualData.terminationFee = this.registerForm.value.terminationFee;
    this.contractualData.bmc = this.registerForm.value.bmc;
    this.contractualData.bmv = this.registerForm.value.bmv;
    this.contractualData.arc = this.registerForm.value.arc;
    this.contractualData.arc2 = this.registerForm.value.arc2;
    this.contractualData.rrc = this.registerForm.value.rrc;
    this.contractualData.rrc2 = this.registerForm.value.rrc2;
    this.contractualData.bandwidth1 = this.registerForm.value.bandwidth1;
    this.contractualData.bandwidth2 = this.registerForm.value.bandwidth2;
    this.contractualData.pxq = this.registerForm.value.pxq;
  }

  getAllChargingMethodology() {
    this.getAllChargingMethodologySubscribe = this.chargingMethodologyService.getAll(this.chargingMethodologyService.baseUrl, null)
      .subscribe(
        (result: any) => {
          this.allCharging = result;
        }
      );
  }

  getAllMonth() {
    this.getPageSubscribe = this.annoMeseService.getAllMonth(this.providerSelect)
      .subscribe(
        (result: any) => {
          this.allMonth = result;
        });
  }

  ngOnDestroy(): void {
    if (this.saveContractualData) {
      this.saveContractualData.unsubscribe();
    }
  }

  /** getElementSelectedLC($event) {
    this.contractualData.localCustomer = $event.row;
    this.localCustomerSelect = $event.row;
    this.registerForm.patchValue({
      localCustomerCod: this.localCustomerSelect.cod
    });
  }

  getElementSelectedContractType($event) {
    this.contractualData.contractType = $event.row;
    this.contractTypeSelect = $event.row;
    this.registerForm.patchValue({
      contractType: this.contractTypeSelect.cod
    });
  }

  getElementSelectedResourceUnit($event) {
    this.contractualData.resourceUnit = $event.row;
    this.resourceUnitSelect = $event.row;
    this.registerForm.patchValue({
      resourceUnit: this.resourceUnitSelect.name
    });
  }

  getElementSelectedProvider($event: any) {
    this.contractualData.provider = $event.row;
    this.providerSelect = $event.row;
    this.registerForm.patchValue({
      providerCod: this.providerSelect.cod
    });
  }

  getElementSelectedSize($event: any) {
    this.contractualData.size = $event.row;
    this.sizeSelect = $event.row;
    this.registerForm.patchValue({
      sizeCod: this.sizeSelect.cod
    });
  }

  getElementSelectedSite($event: any) {
    this.contractualData.site = $event.row;
    this.siteSelect = $event.row;
    this.registerForm.patchValue({
      siteCod: this.siteSelect.cod
    });
  } **/

  getElementSelectRangeList($event) {
    this.contractualData.priceRangeList = $event.priceList;
  }

  handleAnnoFrom(value) {
    this.contractualData.numAnnoMeseFrom = value;
  }

  handleAnnoTo(value) {
    this.contractualData.numAnnoMeseTo = value;
  }

  handleCharging(element) {
    this.contractualData.chargingMethodology = element;
    this.enablePriceRange = this.contractualData.chargingMethodology === this.CHARGING_METHODOLOGY.PRICE_RANGE;
    this.enablePXQ = this.contractualData.chargingMethodology === this.CHARGING_METHODOLOGY.PXQ;
    this.enableArcRrc = this.contractualData.chargingMethodology === this.CHARGING_METHODOLOGY.ARC_RRC;
    this.enableFixed = this.contractualData.chargingMethodology === this.CHARGING_METHODOLOGY.FIXED;
    this.contractualData.compensationPayment = this.registerForm.value.compensationPayment;
    this.contractualData.terminationFee = this.registerForm.value.terminationFee;
    this.contractualData.bmc = this.registerForm.value.bmc;
    this.contractualData.bmv = this.registerForm.value.bmv;
    this.contractualData.arc = 0;
    this.contractualData.arc2 = 0;
    this.contractualData.rrc = 0;
    this.contractualData.rrc2 = 0;
    this.contractualData.bandwidth1 = this.registerForm.value.bandwidth1;
    this.contractualData.bandwidth2 = this.registerForm.value.bandwidth2;

    if (this.enablePriceRange) {
      this.contractualData.bmc = 0;
      this.contractualData.bmv = 0;
      this.contractualData.pxq = 0;
      this.registerForm.patchValue({arc: this.contractualData.arc});
      this.registerForm.patchValue({bmc: this.contractualData.bmc});
      this.registerForm.patchValue({bmv: this.contractualData.bmv});
      this.registerForm.patchValue({rrc: this.contractualData.rrc});
      this.registerForm.patchValue({pxq: this.contractualData.pxq});
    }

    if (this.enablePXQ) {
      this.contractualData.pxq = this.registerForm.value.pxq;
      this.registerForm.patchValue({arc: this.contractualData.arc});
      this.registerForm.patchValue({rrc: this.contractualData.rrc});
    }

    if (this.enableArcRrc) {
      this.contractualData.pxq = 0;
      this.contractualData.arc = this.registerForm.value.arc;
      this.contractualData.rrc = this.registerForm.value.rrc;
      this.registerForm.patchValue({pxq: this.contractualData.pxq});
    }

    if (this.enableFixed) {
      this.contractualData.pxq = 0;
      this.registerForm.patchValue({pxq: this.contractualData.pxq});
      this.registerForm.patchValue({arc: this.contractualData.arc});
      this.registerForm.patchValue({rrc: this.contractualData.rrc});
    }
  }

  checkRangeListValid() {
    let returnValue = false;
    if (this.enablePriceRange) {
      if (this.contractualData.priceRangeList.length > 0) {
        const lastIndexPriceRange = this.contractualData.priceRangeList.length - 1;
        if (this.contractualData.priceRangeList[lastIndexPriceRange].volMax === null) {
          returnValue = true;
        } else {
          toastr.warning('Compile last element range to continue', 'Warning');
          returnValue = false;
        }
      }
    } else {
      returnValue = true;
    }

    return returnValue;
  }

  get f() { return this.registerForm.controls; }

  apriDialog(result: any) {
    const dialogRef = this.dialog.open(DialogSubmitComponent, {
      data: {result}
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log('The dialog was closed');
    });
  }

  resetSize() {
    this.registerForm.patchValue({
      sizeCod: ''
    });
    this.sizeSelect = new SizeModel();
  }

  resetSite() {
    this.registerForm.patchValue({
      siteCod: ''
    });

    this.siteSelect = new SiteModel();
  }

}
